import { render } from "./EditPartnerPopper.vue?vue&type=template&id=3148fea0&scoped=true"
import script from "./EditPartnerPopper.vue?vue&type=script&lang=js"
export * from "./EditPartnerPopper.vue?vue&type=script&lang=js"

import "./EditPartnerPopper.vue?vue&type=style&index=0&id=3148fea0&lang=scss&scoped=true"

import exportComponent from "d:\\Beks\\EasyTicket\\easyticket.webshop.admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3148fea0"]])

export default __exports__